import React, { useState } from 'react';

// Ícone do Google (inalterado)
const GoogleIcon = () => (
    <svg className="h-5 w-5" viewBox="0 0 533.5 544.3" xmlns="http://www.w3.org/2000/svg">
        <path d="M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z" fill="#4285f4"/>
        <path d="M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3H28.9v70.1c46.2 91.9 140.3 149.9 243.2 149.9z" fill="#34a853"/>
        <path d="M119.3 324.3c-11.4-33.8-11.4-70.4 0-104.2V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l90.4-70.1z" fill="#fbbc04"/>
        <path d="M272.1 107.7c38.8-.6 76.3 14 104.4 40.8l77.7-77.7C405 24.6 339.7-.8 272.1 0 169.2 0 75.1 58 28.9 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z" fill="#ea4335"/>
    </svg>
);


export const AuthScreen = ({ onLogin, onRegister, onGoogleLogin, onPasswordReset }) => {
    const [mode, setMode] = useState('login'); // 'login', 'register' ou 'forgotPassword'
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [resetEmail, setResetEmail] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (mode === 'login') {
            onLogin(email, password);
        } else if (mode === 'register') {
            onRegister(email, password);
        }
    };

    const handleGoogleClick = () => {
        onGoogleLogin();
    };

    const handlePasswordResetSubmit = (e) => {
        e.preventDefault();
        onPasswordReset(resetEmail);
    };

    // Estilos originais (pré-redesign) para inputs e botões
    const inputClasses = "mt-1 block w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm sm:text-sm dark:bg-gray-700 dark:text-white focus:ring-blue-500 focus:border-blue-500";
    const buttonClasses = "w-full flex justify-center py-3 px-4 border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400";
    const linkClasses = "text-sm font-medium text-blue-600 hover:text-blue-500"; // Classe para links

    return (
        // --- [FUNDO NOVO] --- Container principal com gradiente e blobs simulados
        <div
            className="min-h-screen flex flex-col items-center justify-center p-4 relative overflow-hidden" // Mudado para flex-col, adicionado relative e overflow-hidden
            // Aplica o gradiente de fundo via style
            style={{ background: 'linear-gradient(135deg, #0A0F1F 0%, #0E1C3A 100%)' }}
        >
            {/* --- Blob Simulado (Canto Esquerdo Inferior) --- */}
            <div className="absolute -bottom-1/4 -left-1/4 w-96 h-96 bg-blue-500 rounded-full opacity-10 filter blur-3xl z-0"></div>
            {/* --- Blob Simulado (Canto Direito Superior) --- */}
            <div className="absolute -top-1/4 -right-1/4 w-80 h-80 bg-cyan-500 rounded-full opacity-10 filter blur-3xl z-0"></div>

            {/* --- Conteúdo centralizado e acima dos blobs --- */}
            <div className="relative z-10 w-full max-w-md">

                {/* --- Seção do Logo (Estrutura anterior) --- */}
                <div className="w-full mb-6 p-6 bg-gray-800 rounded-xl shadow-lg">
                     <img
                        src="https://i.imgur.com/xWfURLO.png" // Sua URL do logo
                        alt="Logo MovMei"
                        className="h-16 w-auto mx-auto"
                    />
                </div>
                {/* --- Fim da seção do Logo --- */}


                {/* --- Card do Formulário (Estrutura anterior) --- */}
                <div className="w-full bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8">

                    {/* Título dinâmico */}
                    <h1 className="text-2xl font-bold text-center text-gray-800 dark:text-gray-200 mb-6">
                        {mode === 'login' && 'Acessar minha conta'}
                        {mode === 'register' && 'Criar nova conta'}
                        {mode === 'forgotPassword' && 'Recuperar Senha'}
                    </h1>

                    {/* Formulário Principal (Login/Registro) */}
                    {mode !== 'forgotPassword' && (
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div>
                                <label htmlFor="email" className="dark:text-gray-300">Email</label>
                                <input
                                    type="email" name="email" id="email" value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required className={inputClasses} // Estilo original
                                />
                            </div>

                            <div>
                                <label htmlFor="password" className="dark:text-gray-300">Senha</label>
                                <input
                                    type="password" name="password" id="password" value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required minLength="6" className={inputClasses} // Estilo original
                                />
                                {mode === 'login' && (
                                    <div className="text-right mt-2">
                                        <button
                                            type="button"
                                            onClick={() => setMode('forgotPassword')}
                                            className={linkClasses} // Estilo original
                                        >
                                            Esqueci minha senha
                                        </button>
                                    </div>
                                )}
                            </div>

                            <div>
                                <button type="submit" className={buttonClasses}> {/* Estilo original */}
                                    {mode === 'login' ? 'Entrar' : 'Criar Conta'}
                                </button>
                            </div>
                        </form>
                    )}

                    {/* Formulário de Recuperação */}
                    {mode === 'forgotPassword' && (
                         <form onSubmit={handlePasswordResetSubmit} className="space-y-6">
                             <p className="text-sm text-gray-600 dark:text-gray-400 text-center">
                                Digite seu e-mail cadastrado abaixo. Enviaremos um link para você criar uma nova senha.
                             </p>
                            <div>
                                <label htmlFor="resetEmail" className="dark:text-gray-300">Email Cadastrado</label>
                                <input
                                    type="email" name="resetEmail" id="resetEmail" value={resetEmail}
                                    onChange={(e) => setResetEmail(e.target.value)}
                                    required placeholder="seuemail@exemplo.com"
                                    className={inputClasses} // Estilo original
                                />
                            </div>
                            <div>
                                <button type="submit" className={buttonClasses}> {/* Estilo original */}
                                    Enviar e-mail de recuperação
                                </button>
                            </div>
                         </form>
                    )}


                    {/* Divisor "ou" */}
                    {mode !== 'forgotPassword' && (
                        <div className="flex items-center justify-center my-6">
                            <span className="h-px bg-gray-300 dark:bg-gray-600 flex-1"></span> {/* Linha original */}
                            <span className="px-4 text-sm text-gray-500 dark:text-gray-400">ou</span>
                            <span className="h-px bg-gray-300 dark:bg-gray-600 flex-1"></span> {/* Linha original */}
                        </div>
                    )}

                    {/* Botão Google */}
                    {mode !== 'forgotPassword' && (
                        <div>
                            <button
                                type="button"
                                onClick={handleGoogleClick}
                                className="w-full flex justify-center items-center py-3 px-4 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" // Estilo original
                            >
                                <GoogleIcon />
                                <span className="ml-3">Entrar com Google</span>
                            </button>
                        </div>
                    )}

                    {/* Links inferiores */}
                    <div className="text-center mt-6">
                        {mode === 'login' && (
                            <p className="text-sm text-gray-600 dark:text-gray-400">
                                Não tem uma conta?{' '}
                                <button onClick={() => setMode('register')} className={linkClasses}> {/* Estilo original */}
                                    Crie uma agora
                                </button>
                            </p>
                        )}
                        {mode === 'register' && (
                            <p className="text-sm text-gray-600 dark:text-gray-400">
                                Já tem uma conta?{' '}
                                <button onClick={() => setMode('login')} className={linkClasses}> {/* Estilo original */}
                                    Faça o login
                                </button>
                            </p>
                        )}
                        {mode === 'forgotPassword' && (
                             <p className="text-sm text-gray-600 dark:text-gray-400">
                                Lembrou a senha?{' '}
                                <button onClick={() => setMode('login')} className={linkClasses}> {/* Estilo original */}
                                    Voltar para o Login
                                </button>
                            </p>
                        )}
                    </div>

                </div> {/* Fim do card do formulário */}
            </div> {/* Fim do container do conteúdo centralizado */}
        </div> // Fim do container principal
    );
};